import { render, staticRenderFns } from "./CreatedSchool.vue?vue&type=template&id=23a321df&scoped=true"
import script from "./CreatedSchool.vue?vue&type=script&lang=js"
export * from "./CreatedSchool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a321df",
  null
  
)

export default component.exports